/* Behavior - behaviors/slide.js */

$(function () {
    var $brands = $('.sec-brands .owl-carousel');

    if(!$brands.length) return

    $brands.owlCarousel({
        items: 1,
        autoplay: true,
        loop: false,
        navContainer: $('.sec-brands .slide-navs_inner'),
        rewind: true,
        dots: false,
        nav: true,
        margin: 30,
        navElement: 'span',
        navText : ['<span><span>Anterior</span></span>','<span><span>Próximo</span></span>'],
        navSpeed: 500,
        dotsSpeed: 500,
        dragEndSpeed: 500,
        autoplaySpeed: 500,
        autoplayTimeout: 6000,       
    });

    var $brandsNavs = $('.sec-brands .slide-navs_inner.disabled');
    
    if(!$brandsNavs.length) return
    $('.sec-brands .slide-navs').addClass('disabled');
});